module.exports = __webpack_public_path__ + "static/media/deciphex.4eb04710.png";